<template>
  <div class="list-page">
    <div class="school-title">{{ school_title }}</div>
    <div class="table">
      <el-breadcrumb class="sub-nav-box" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/planList' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>复检名单</el-breadcrumb-item>
      </el-breadcrumb>

      <el-row :gutter="15" class="select-box">
        <el-col :span=4>
          <el-select v-model="form.section_id" placeholder="请选择学段" size="small" @change="getGradeOptions">
            <el-option v-for="item in SectionOptions" :key="item.id" :label="item.title" :value="item.id"> </el-option>
          </el-select>
        </el-col>
        <el-col :span=4>
          <el-select v-model="form.grade_id" placeholder="请选择年级" size="small" @change="getClassOptions">
            <el-option v-for="item in GradeOptions" :key="item.id" :label="item.title" :value="item.id"> </el-option>
          </el-select>
        </el-col>
        <el-col :span=4>
          <el-select v-model="form.class_id" placeholder="请选择班级" size="small" @change="getClassTitle">
            <el-option v-for="item in ClassOptions" :key="item.id" :label="item.title" :value="item.id"> </el-option>
          </el-select>
        </el-col>
        <el-col :span=4>
          <el-button type="primary" size="small" @click="searchFn()">搜 索</el-button>
        </el-col>
      </el-row>

      <div class="table-list-box">
        <el-table :data="tableData" v-loading="tableConfig.load" :style="tableConfig.style"
          :height="tableConfig.maxHeight" :border=tableConfig.border :size="tableConfig.size">
          <el-table-column v-if="tableConfig.selection === true" type="selection" width="55"> </el-table-column>
          <template v-for="(item, index) of tableConfig.config">
            <el-table-column v-if="item.id === 'radio'" :key="'radio' + index" :label="item.name"
              :align="tableConfig.align ? tableConfig.align : 'center'">
              <template slot-scope="scope">
                <el-radio v-model="radio" :label="scope.row.id"></el-radio>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.id === 'operation'" :key="index" :prop="item.id" :label="item.name"
              :align="tableConfig.align ? tableConfig.align : 'center'" :width="item.width">
              <template> <el-button v-for="n in item.list" :key="n.id" type="text" size="small" :class="n.className">{{
                n.name }}</el-button> </template>
            </el-table-column>
            <el-table-column v-else :label="item.name" :key="index" :prop="item.id"
              :align="tableConfig.align ? tableConfig.align : 'center'" :width="item.width"
              :type="item.type"></el-table-column>
          </template>
        </el-table>
      </div>
    </div>
    <div class="page">
      <el-pagination :background="false" @current-change="handleCurrentChange" :current-page.sync="currentPage"
        :page-size="this.limit" layout="prev,total, next" :total="total"> </el-pagination>
    </div>
  </div>
</template>

<script>
import { APIGETRECHECKLIST, APIGETSECTIONOPTIONS, APIGEGRADEOPTIONS, APIGETCLASSOPTIONS } from "@/common/api"
import { getStorage } from '@/common/storage'
export default {
  name: 'studentInfo',
  data() {
    return {
      currentPage: 1,
      total: 0,
      limit: 10,
      SectionOptions: [],
      GradeOptions: [],
      ClassOptions: [],
      form: {
        section_id: "",
        grade_id: '',
        class_id: '',
      },
      conditions: {
        plan_id: "",
        school_id: '',
        token: '',
        section_title: '',
        grade_title: '',
        class_title: '',
        page: 1,
        // status: 1, //查看未完成
      },
      tableConfig: {
        load: true,
        size: 'small', // 表格大小
        style: 'width:100%', // 表格宽度
        maxHeight: "100%",
        align: 'center',
        selection: false,
        border: true,
        config: [
          { id: 'real_name', name: '姓名' },
          { id: 'account', name: '账号' },
          // {id: 'school_title', name: '学校'},
          { id: 'grade_title', name: '年级' },
          { id: 'class_title', name: '班级' },
          // {id: 'evaluation_total_time', name: '用时（分钟）'},
          // {id: 'finish_status', name: '完成情况'},
          // {id: 'ts', name: '完成时间'}
        ]
      },
      tableData: [],
      school_title: getStorage('school_title')
    }
  },
  created() {
    this.conditions.school_id = getStorage('school_id')
    this.conditions.token = getStorage('token')
    this.dataList()
    this.getSectionOptions()
  },
  methods: {
    //搜索
    searchFn() {
      this.dataList()
    },
    //学段
    getSectionOptions() {
      APIGETSECTIONOPTIONS(this.conditions).then((res) => {
        // console.log(res.data);
        this.SectionOptions = res.data
      }).catch((err) => {
        this.$message.error(err.msg)
      })
    },
    //年级
    getGradeOptions() {
      this.form.grade_id = ''
      this.form.class_id = ''
      APIGEGRADEOPTIONS({
        section_id: this.form.section_id,
        token: this.conditions.token
      }).then((res) => {
        this.GradeOptions = res.data
        this.conditions.section_title = this.SectionOptions.find(item => item.id == this.form.section_id)['title']
        console.log(this.conditions.section_title);
      }).catch((err) => {
        this.$message.error(err.msg)
      })
    },
    //获取班级列表
    getClassOptions() {
      APIGETCLASSOPTIONS({
        grade_id: this.form.grade_id,
        token: this.conditions.token
      }).then((res) => {
        this.conditions.grade_title = this.GradeOptions.find(item => item.id == this.form.grade_id)['title']
        this.ClassOptions = res.data
      }).catch((err) => {
        this.$message.error(err.msg)
      })
    },
    //获取班级名称
    getClassTitle() {
      this.conditions.class_title = this.ClassOptions.find(item => item.id == this.form.class_id)['title']
    },
    dataList() {
      this.conditions.plan_id = this.$route.query.id

      APIGETRECHECKLIST(this.conditions).then((res) => {
        console.log(res);
        this.total = res.data.list.totalNumber
        this.currentPage = res.data.list.page
        this.tableData = res.data.list.list
        this.tableConfig.load = false
        // this.completion_rate = res.data.completion_rate
        // this.evaluate_completed_number = res.data.evaluate_completed_number
        // this.evaluate_number = res.data.evaluate_number
        // this.not_finished_number = res.data.not_finished_number
      }).catch((err) => {
        this.$message.error(err.msg)
      })
    },
    check() {
      history.go(-1)
    },
    handleCurrentChange(val) { // 分页
      console.log(val);
      this.conditions.page = val
      this.dataList()
    },
  }


}
</script>

<style lang="scss" scoped>
.list-page {
  height: 100%;

  .table {
    height: calc(100% - 120px);
  }

  .school-title {
    background: #4c5bf7;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
    text-align: center;
    width: 100%;
    height: 50px;
    line-height: 50px;
    box-sizing: border-box;
    padding: 0 10px;
  }

  .sub-nav-box {
    padding: 10px;
    box-sizing: border-box;
  }

  .select-box {
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
  }

  .table-list-box {
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 80px);
  }

  .page {
    padding: 20px 0;
    box-sizing: border-box;
    height: 70px;

    .el-pagination {
      text-align: center;
    }
  }

}
</style>